import script from "./PhoneMySpace.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMySpace.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMySpace.vue?vue&type=style&index=0&id=2cf54cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf54cfc"]])

export default __exports__